import { useRecoilValue } from "recoil";

import styled from "styled-components";
import { toastListState } from "../../atom/atom";
import ToastItem from "./ToastItem";

function ToastList() {
  const toastList = useRecoilValue(toastListState);
  return (
    <StToastList>
      {toastList.map((toast) => (
        <ToastItem key={toast.id} {...toast} />
      ))}
    </StToastList>
  );
}
const StToastList = styled.div`
  bottom: 0;
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
  z-index: 1000;
  pointer-events: none;
`;

export default ToastList;
